"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Injectable = exports.defaultInjectableOptions = void 0;
require("reflect-metadata");
const injector_1 = require("./injector");
/**
 * The default options for the injectable classes
 */
exports.defaultInjectableOptions = {
    lifetime: 'transient',
};
/**
 * Decorator method for tagging a class as injectable
 * @param options The options object
 */
const Injectable = (options) => {
    return (ctor) => {
        const meta = Reflect.getMetadata('design:paramtypes', ctor);
        const metaValue = {
            dependencies: (meta &&
                meta.map((param) => {
                    return param;
                })) ||
                [],
            options: Object.assign(Object.assign({}, exports.defaultInjectableOptions), options),
        };
        injector_1.Injector.meta.set(ctor, metaValue);
    };
};
exports.Injectable = Injectable;
//# sourceMappingURL=injectable.js.map